import { render, staticRenderFns } from "./BookingOtherDetailView.vue?vue&type=template&id=337ff9dd&scoped=true&"
import script from "./BookingOtherDetailView.vue?vue&type=script&lang=js&"
export * from "./BookingOtherDetailView.vue?vue&type=script&lang=js&"
import style0 from "./BookingOtherDetailView.vue?vue&type=style&index=0&id=337ff9dd&scoped=true&lang=css&"
import style1 from "./BookingOtherDetailView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ff9dd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337ff9dd')) {
      api.createRecord('337ff9dd', component.options)
    } else {
      api.reload('337ff9dd', component.options)
    }
    module.hot.accept("./BookingOtherDetailView.vue?vue&type=template&id=337ff9dd&scoped=true&", function () {
      api.rerender('337ff9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingOtherDetailView.vue"
export default component.exports